import log from "loglevel";
import React, { useEffect, useState } from 'react';
import { Modal, Button,OverlayTrigger, Form, Tooltip, ListGroup } from 'react-bootstrap';
import httpService from 'services/httpService';
import * as constants from 'Constants';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import { AiOutlineCloudUpload } from "react-icons/ai";

function PushToRepoExp( {lab_id, lab_title, id, course} ) {
    const [showTagModal, setShowTagModal] = useState(false);
    const [TagInput, setTagInputValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [selectedTags, setSelectedTags] = useState(['set']);

    const handleClose = () => setShowTagModal(false);
    const handleShow = () => setShowTagModal(true);

    useEffect(() => {
        const fetchCourseTitle = async () => {
            try {
                const response = await httpService.get(
                    `${constants.base_url}/vlab/repository/${course}/?type=course`,
                    { responseType: 'json' }
                );
                setTagInputValue(`${response.data.course},${lab_title}`);
            } catch (error) {
                log.error('Error fetching course title:', error);
            }
        };
    
        fetchCourseTitle();
    }, []); // Added dependencies to ensure useEffect runs when these values change
    

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission behavior
        setLoading(true);
    
        let form_data = new FormData();
        form_data.append("id", id);
        form_data.append("tags", TagInput);
        let url = constants.base_url + "/vlab/repository/" + id + "/";
    
        try {
            const res = await httpService.post(url, form_data, {
                headers: {
                    "content-type": "application/json",
                },
            });
            log.log("Pushed to Repository");
            displayGlobalMessage(`Pushed to Repository`, "success");
        } catch (err) {
            // displayGlobalMessage(`${err.response.data.detail[0]}`, "error");
            if (err.response && err.response.data && err.response.data.detail) {
                displayGlobalMessage(`${err.response.data.detail}`, "error");
            } else {
                displayGlobalMessage("Unknown error occurred", "error");
            }
        } finally {
            setLoading(false);
            handleClose();
        }
    };
    
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Push to Repository
        </Tooltip>
    );
    const handleInputChange = async (e) => {
        const inputValue = e.target.value;
        setTagInputValue(inputValue);
        const tags = inputValue.split(",");
        const tag = tags[tags.length - 1].trim(); // Get last tag
    
        try {
            // Make GET request to fetch suggestions
            const response = await httpService.get(
                `${constants.base_url}/vlab/repository/${lab_id}?type=tags&suggest=${tag}`,
                {
                    responseType: 'json',
                }
            );
            setSuggestions(response.data.tags); // Assuming response.data is an array of suggestions
        } catch (error) {
            log.error('Error fetching suggestions:', error);
        }
    };
    
    const handleSuggestionClick = (e, suggestion) => {
        e.preventDefault();
        var tag_input = TagInput.split(",");
        tag_input.pop(); // Remove last tag
        tag_input = tag_input.join(",") + ","; // Join tags and append comma
        setTagInputValue(tag_input + suggestion); // Append suggestion to tag input
        setSelectedTags([...selectedTags, suggestion]); // Add suggestion to selectedTags array
    };


    return (
        <>
            <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id="button-tooltip">Push to Repository</Tooltip>}
            >
                <AiOutlineCloudUpload size="30" onClick={handleShow} />
            </OverlayTrigger>

            <Modal show={showTagModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Push to Repository</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="TagInput">
                            <Form.Label>Tag Input</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter search input"
                                value={TagInput}
                                onChange={handleInputChange}
                            />
                            <ListGroup>
                                {Array.isArray(suggestions) && suggestions.map((suggestion, index) => (
                                    <ListGroup.Item
                                        key={index}
                                        action
                                        onClick={(e) => handleSuggestionClick(e,suggestion)}
                                    >
                                        {suggestion}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Form.Group>
                        <Button variant="secondary" onClick={handleClose} disabled={loading}>
                            Close
                        </Button>
                        <Button variant="primary" type="submit" disabled={loading}>
                            {loading ? 'Loading...' : 'Submit'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default PushToRepoExp;